window.addEventListener('click', async (event) => {
    const button = event.target.closest('.product-stock-promo .promo-copy, .product-stock-promo [data-copy-code]');
    if (!button) {
        return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    button.type = 'button';
    if (button.disabled) {
        return;
    }

    const container = button.parentElement;
    const codeElement = container.querySelector('.promo-code, code');
    const legacyCode = container.querySelector('strong')?.textContent.match(/(?:kódem|kódom|code)\s+([a-z0-9_-]+)/i);
    const code = button.dataset.copyCode || codeElement?.textContent.trim() || legacyCode?.[1];
    if (!code) {
        return;
    }

    const status = container.querySelector('.promo-copy-status');
    button.disabled = true;

    try {
        let copied = false;
        if (navigator.clipboard && window.isSecureContext) {
            try {
                await navigator.clipboard.writeText(code);
                copied = true;
            } catch {}
        }

        if (!copied) {
            const field = document.createElement('textarea');
            const previousFocus = document.activeElement;
            field.value = code;
            field.readOnly = true;
            field.style.cssText = 'position:fixed;left:-9999px;top:0';
            document.body.appendChild(field);
            try {
                field.select();
                if (!document.execCommand('copy')) {
                    throw new Error('Copy failed');
                }
            } finally {
                field.remove();
                if (previousFocus) {
                    previousFocus.focus();
                }
            }
        }

        button.classList.add('is-copied');
        if (status) {
            status.textContent = button.dataset.successLabel || 'Zkopírováno';
        }
        setTimeout(() => {
            button.classList.remove('is-copied');
            button.disabled = false;
            if (status) {
                status.textContent = '';
            }
        }, 2500);
    } catch {
        button.disabled = false;
        if (status) {
            status.textContent = button.dataset.errorLabel || 'Kód se nepodařilo zkopírovat.';
        }
    }
}, true);